import { Fragment, useCallback, useMemo } from 'react';
import DraggableDrawer from '../draggable-drawer/DraggableDrawer';
import NavigationConfig from './models/navigation-config.interface';
import TabDrawerTab from './tab-drawer-tab/TabDrawerTab';
import TabDrawerProps from './TabDrawer.props';

const TabDrawer = ({
  navigationConfig,
  activeTabId,
  onTabSelect,
  sidePanel,
  headerLeading,
  contentWrapperSx,
  headerContentSx,
  expandRef,
  contextKey,
}: TabDrawerProps) => {
  const selectedTab = useMemo(() => {
    if (activeTabId) {
      const foundTab = navigationConfig.find(config => config.uniqueId === activeTabId);
      if (foundTab) {
        return foundTab;
      }
      // If activeTabId doesn't exist, don't fall back automatically
      // Let the parent component handle this
      return null;
    }
    return navigationConfig.length > 0 ? navigationConfig[0] : null;
  }, [navigationConfig, activeTabId]);

  const handleTabClick = useCallback(
    (tabConfiguration: NavigationConfig) => {
      onTabSelect?.(tabConfiguration.uniqueId);
    },
    [onTabSelect]
  );

  const headerTabs = useMemo(
    () =>
      navigationConfig.map(config => (
        <TabDrawerTab
          key={config.uniqueId}
          uniqueId={config.uniqueId}
          onClick={() => handleTabClick(config)}
          tabTitle={config.tabTitle}
          icon={config.icon}
          isActive={config.uniqueId === selectedTab?.uniqueId}
          onClose={config.onClose && (() => config.onClose?.(config.uniqueId))}
          secondaryActions={config.secondaryActions}
        />
      )),
    [navigationConfig, selectedTab, handleTabClick]
  );

  return (
    <DraggableDrawer
      headerContent={
        <>
          {headerLeading}
          {headerTabs}
        </>
      }
      open
      sidePanel={sidePanel}
      contentWrapperSx={contentWrapperSx}
      headerContentSx={headerContentSx}
      expandRef={expandRef}
      contextKey={contextKey}>
      {selectedTab ? <Fragment key={selectedTab.uniqueId}>{selectedTab.tabContent}</Fragment> : null}
    </DraggableDrawer>
  );
};

export default TabDrawer;
